import {
  NewButton,
  NewButtonSize,
  NewButtonVariant,
} from "@visiblethread/react-components";
import clsx from "clsx";
import AssigneePicker from "components/AssigneePicker";
import AvatarGroup from "components/AvatarGroup";
import { idPropType } from "constants/app";
import { ENTITY_TYPE_PATH } from "constants/entityTypes";
import { PenLine } from "lucide-react";
import {
  arrayOf,
  func,
  number,
  oneOf,
  oneOfType,
  shape,
  string,
} from "prop-types";
import { useRef, useState } from "react";

import classes from "./AssigneeEditor.module.scss";

const AssigneeEditor = ({
  assignees = [],
  max,
  entityType,
  entityId,
  onAssigneesChange,
  emptyLabel = "Not Assigned",
  className,
  onBeforeCommit,
}) => {
  const [isPickerOpen, setIsPickerOpen] = useState(false);
  const triggerRef = useRef(null);
  const hasAssignees = assignees?.length > 0;

  return (
    <div
      ref={triggerRef}
      className={clsx(classes.assignee_editor__root, className)}
    >
      {hasAssignees ? (
        <button
          type="button"
          className={clsx(
            classes.assignee_editor,
            classes["assignee_editor--assigned"]
          )}
          onClick={() => setIsPickerOpen((prev) => !prev)}
          aria-label="Edit Assignees"
          data-testid="assignee-editor-edit-button"
        >
          <AvatarGroup assignees={assignees} max={max} />
          <PenLine
            size={14}
            className={classes.assignee_editor__icon}
            data-show-on-row-hover
            data-testid="assignee-editor-hover-icon"
          />
        </button>
      ) : (
        <div className={classes.assignee_editor__unassigned}>
          <span className={classes.assignee_editor__unassigned_text}>
            {emptyLabel}
          </span>
          <NewButton
            size={NewButtonSize.sm}
            variant={NewButtonVariant.dashed}
            data-show-on-row-hover
            data-testid="assignee-editor-edit-button"
            onClick={() => setIsPickerOpen((prev) => !prev)}
            className={classes.assignee_editor__unassigned_button}
          >
            Assign
          </NewButton>
        </div>
      )}

      {isPickerOpen && (
        <AssigneePicker
          entityType={entityType}
          entityId={entityId}
          assignees={assignees}
          triggerRef={triggerRef}
          onClose={() => setIsPickerOpen(false)}
          onAssigneesChange={onAssigneesChange}
          onBeforeCommit={onBeforeCommit}
        />
      )}
    </div>
  );
};

AssigneeEditor.propTypes = {
  assignees: arrayOf(
    shape({
      workspaceUserId: idPropType.isRequired,
      userName: string,
      firstName: string,
      lastName: string,
      assignedAt: string,
    })
  ),
  max: number,
  entityType: oneOf(Object.keys(ENTITY_TYPE_PATH)).isRequired,
  entityId: oneOfType([number, string]).isRequired,
  onAssigneesChange: func,
  emptyLabel: string,
  className: string,
  onBeforeCommit: func,
};

export default AssigneeEditor;
